import { Skeleton, VStack } from '@chakra-ui/react';
import React, { useMemo } from 'react';

import { InvoiceFragmentGQLType } from 'types/dashboard-core-gqlTypes.generated';

import { useGetInvoicePaymentInKindItemsByInvoiceIdQuery } from 'packages/invoices/requests/invoices.gql.generated';
import { InvoicePaymentInKindTable } from 'packages/invoices/ui/paymentInKind/InvoicePaymentInKindTable';
import { groupPaymentInKindInvoiceReportsByCapitalizedLoanId } from 'packages/invoices/ui/utils';

export const InvoicePaymentInKindItems = ({
  invoice,
}: {
  invoice: InvoiceFragmentGQLType;
}) => {
  const {
    data: invoicePaymentInKindItemsData,
    loading: isInvoicePaymentInKindItemsLoading,
  } = useGetInvoicePaymentInKindItemsByInvoiceIdQuery({
    variables: { invoiceId: invoice.id },
    fetchPolicy: 'network-only',
  });

  const paymentInKindInvoiceReports = useMemo(() => {
    if (
      !invoicePaymentInKindItemsData?.getInvoicePaymentInKindItemsByInvoiceId
    ) {
      return null;
    }

    return groupPaymentInKindInvoiceReportsByCapitalizedLoanId({
      invoiceReports: invoice.invoiceReports ?? [],
      invoicePaymentInKindItems: invoicePaymentInKindItemsData.getInvoicePaymentInKindItemsByInvoiceId.flatMap(
        (item) => item.invoicePaymentInKindItems,
      ),
    });
  }, [invoice.invoiceReports, invoicePaymentInKindItemsData]);

  if (isInvoicePaymentInKindItemsLoading || !invoicePaymentInKindItemsData) {
    return <Skeleton height="200px" />;
  }

  if (
    invoicePaymentInKindItemsData.getInvoicePaymentInKindItemsByInvoiceId
      .length === 0
  ) {
    return null;
  }

  return (
    <>
      {invoicePaymentInKindItemsData.getInvoicePaymentInKindItemsByInvoiceId.map(
        (invoicePaymentInKindItemsForCapitalizedLoan) => {
          return (
            <VStack
              key={
                invoicePaymentInKindItemsForCapitalizedLoan.capitalizedLoanId
              }
              gap="40px"
              w="100%"
            >
              <InvoicePaymentInKindTable
                invoicePaymentInKindItemsWithMetadata={
                  invoicePaymentInKindItemsForCapitalizedLoan
                }
                invoiceReportsForCapitalizedLoan={
                  paymentInKindInvoiceReports?.[
                    invoicePaymentInKindItemsForCapitalizedLoan
                      .capitalizedLoanId
                  ] ?? []
                }
                invoiceLoanId={invoice.finleyLoanId ?? undefined}
                invoiceCreditFacilityId={invoice.creditFacilityId}
              />
            </VStack>
          );
        },
      )}
    </>
  );
};
